import GoToAppOrStore from '@/components/GoToAppOrStore';
import Constants from '@/Constants';
import { analyticsService, FlowEvents } from '@/services/AnalyticsService';
import { redirectToStore } from '@/services/UtilService';
import React, { useEffect } from 'react';
import { isAndroid, isIOS, isMobileOnly } from 'react-device-detect';
import { useHistory, useParams } from 'react-router-dom';

const Recommendation: React.FC = () => {
    const history = useHistory();
    const { contentId } = useParams<{ contentId: string }>();

    useEffect(() => {
        analyticsService.logEvent(FlowEvents.ACCESS_RECOMMENDATION_ITEM_BY_EMAIL);
        if (isMobileOnly && (isAndroid || isIOS)) {
            isAndroid && setTimeout(() => redirectToStore(isIOS), 2000);
            window.location.href = Constants.mobileApp.APP_RECOMMENDATIONS_DEEP_LINK + contentId;
        } else {
            history.replace(`/contents/${contentId}`);
        }
    }, []);

    return <GoToAppOrStore />;
};

export default Recommendation;
